import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import HomeView from '../views/HomeView.vue';
import PublicLayoutVue from '@/layouts/PublicLayout.vue';
import authLayoutVue from '@/layouts/authLayout.vue';
import dashboardLayoutVue from '@/layouts/dashboardLayout.vue';
import dashboardMeLayoutVue from '@/layouts/dashboardMeLayout.vue';
import { useAuthStore } from '@/stores/auth.store';
import qrEditorLayoutVue from '@/layouts/qrEditorLayout.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    component: PublicLayoutVue,
    children: [
      {
        path: '',
        name: 'Home',
        component: HomeView,
        meta: {
          redirectIsAuth: true
        }
      }
    ]
  },
  {
    path: '/',
    component: authLayoutVue,
    children: [
      {
        path: '/signup',
        name: 'SignUp',
        component: () => import(/* webpackChunkName: "SignUp" */ '../views/AuthSignUpView.vue')
      },
      {
        path: '/signin',
        name: 'SignIn',
        component: () => import(/* webpackChunkName: "SignIn" */ '../views/AuthSignInView.vue')
      },
      {
        path: '/signin/reset',
        name: 'RememberPsw',
        component: () => import(/* webpackChunkName: "RememberPsw" */ '../views/AuthRememberPswView.vue')
      }
    ],
    meta: {
      redirectIsAuth: true
    }
  },
  {
    path: '/',
    component: qrEditorLayoutVue,
    children: [
      {
        path: '/qr-generator',
        name: 'QrBuilderSelectTypeRoute',
        component: () => import(/* webpackChunkName: "QrBuilderSelectTypeRoute" */ '../views/QrBuilderSelectTypeView.vue')
      },
      {
        path: '/qr-generator/builder',
        name: 'QrBuilderFormRoute',
        component: () => import(/* webpackChunkName: "QrBuilderFormRoute" */ '../views/QrBuilderFormView.vue')
      }
    ]
  },
  {
    path: '/',
    component: dashboardLayoutVue,
    children: [
      {
        path: '/dashboard',
        name: 'Dashboard',
        component: () => import(/* webpackChunkName: "Dashboard" */ '../views/DashboardView.vue')
      },
      {
        path: '/analytics',
        name: 'Analytics',
        component: () => import(/* webpackChunkName: "DashboardAnalytics" */ '../views/DashboardAnalyticsView.vue')
      },
      {
        path: '/folders',
        name: 'Folders',
        component: () => import(/* webpackChunkName: "DashboardFolders" */ '../views/DashboardFoldersView.vue')
      },
      {
        path: '/team',
        name: 'Team',
        component: () => import(/* webpackChunkName: "DashboardTeam" */ '../views/DashboardTeamView.vue')
      },
      {
        path: '/me',
        component: dashboardMeLayoutVue,
        children: [
          {
            path: 'account',
            name: 'MeAccount',
            component: () => import(/* webpackChunkName: "DashboardMeAccount" */ '../views/DashboardMeAccount.vue')
          },
          {
            path: 'tax-info',
            name: 'MeTaxData',
            component: () => import(/* webpackChunkName: "DashboardMeAccount" */ '../views/DashboardMeTaxData.vue')
          }
        ]
      }
    ],
    meta: {
      requiresAuth: true
    }
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to) {
    return new Promise(resolve => {
      setTimeout(() => {
        if (to.hash) {
          resolve({
            el: to.hash,
            behavior: 'smooth',
            top: 20
          });
        } else {
          resolve({
            top: 0,
            behavior: 'smooth'
          });
        }
      }, 1);
    });
  }
});

router.beforeEach((to, from, next) => {
  const AuthStore = useAuthStore();
  if (to.meta.requiresAuth && !AuthStore.userIsLogged) return next({ name: 'SignIn' });
  else if (to.meta.redirectIsAuth && AuthStore.userIsLogged) return next({ name: 'Dashboard' });

  return next();
});

export default router;
